
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vydavatelstvi",
      function () {
        return require("private-next-pages/vydavatelstvi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vydavatelstvi"])
      });
    }
  